// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2y06f","footer":"ModalInfo_footer__WOhCn"};